import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { FC, ReactElement } from "react";

interface IEmployeeCardListItemProps {
  icon: ReactElement;
  text: string | null;
}

const EmployeeCardListItem: FC<IEmployeeCardListItemProps> = ({
  icon,
  text,
}) => (
  <ListItem>
    <ListItemIcon
      sx={{
        minWidth: "40px",
      }}
    >
      {icon}
    </ListItemIcon>
    <ListItemText
      primary={text || "-"}
      slotProps={{
        primary: {
          variant: "subtitle2",
          color: "text.secondary",
          fontWeight: 400,
        },
      }}
    />
  </ListItem>
);

export default EmployeeCardListItem;
